export const getQuantifyQueryRetentionKey = (
  tenantSlug: string | undefined,
) => {
  return `quantifyQueryRetentionKey_${tenantSlug}`;
};
